<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.99982 6.00003V8.6667M7.99982 11.3334H8.00648M7.0767 2.59451L1.59344 12.0656C1.2893 12.5909 1.13723 12.8536 1.15971 13.0692C1.17931 13.2572 1.27783 13.4281 1.43073 13.5392C1.60604 13.6667 1.90954 13.6667 2.51656 13.6667H13.4831C14.0901 13.6667 14.3936 13.6667 14.5689 13.5392C14.7218 13.4281 14.8203 13.2572 14.8399 13.0692C14.8624 12.8536 14.7103 12.5909 14.4062 12.0656L8.92294 2.59451C8.61989 2.07107 8.46837 1.80935 8.27068 1.72145C8.09824 1.64477 7.90139 1.64477 7.72895 1.72145C7.53126 1.80935 7.37974 2.07107 7.0767 2.59451Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
